import { type KeyboardEvent, useEffect, useRef, useState } from 'react';

export function useAsyncSelectorPopover() {
  const [open, setOpen] = useState(false);
  const [pickModalOpen, setPickModalOpen] = useState(false);
  const wrapRef = useRef<HTMLDivElement>(null);
  // Popover je portálovaný do document.body (mimo wrapRef), proto se musí na klik
  // mimo testovat zvlášť — jinak by klik dovnitř popoveru spadl jako „klik mimo".
  const popRef = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  const pickerActive = open || pickModalOpen;

  useEffect(() => {
    if (!open) return;
    const onDoc = (event: MouseEvent) => {
      const target = event.target as Node | null;
      if (!target) return;
      if (wrapRef.current?.contains(target)) return;
      if (popRef.current?.contains(target)) return;
      setOpen(false);
    };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, [open]);

  const handleKey = (event: KeyboardEvent<HTMLInputElement>) => {
    if (!open && (event.key === 'ArrowDown' || event.key === 'Enter')) {
      setOpen(true);
      return;
    }
    if (!open) return;
    if (event.key === 'Escape') {
      setOpen(false);
    }
  };

  return {
    open,
    setOpen,
    pickModalOpen,
    setPickModalOpen,
    wrapRef,
    popRef,
    inputRef,
    pickerActive,
    handleKey,
  };
}
